module.exports = __webpack_public_path__ + "img/limonada.82fbfcf7.jpg";